import { createI18n } from 'vue-i18n'
import { defaultLanguage, supportLanguage } from '@/consts/index'
import { getDeviceInfo } from '@u/native.js'

const requireFiles = ((context) => {
  const fileObj = {}
  context.keys().forEach((url) => {
    const fileName = (url.match(/((\w)+)\.json/) || [])[1]
    const lng = (url.match(/[a-z_A-Z]+/) || [])[0]
    if (!fileObj[lng]) {
      fileObj[lng] = {}
    }
    fileObj[lng][fileName] = context(url)
  })
  return fileObj
})(require.context('./', true, /\.json$/))

const deviceInfo = getDeviceInfo() || {}
const { language = '' } = deviceInfo
const locale = (language && supportLanguage[language]) || defaultLanguage

export const setupI18n = createI18n({
  locale, // 设置地区
  fallbackLocale: defaultLanguage,
  messages: requireFiles,
  legacy: false,
  globalInjection: true,
})
